const { makeStyles } = require('@material-ui/core');

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    padding: '0 0.5rem'
  },
  content: {
    [theme.breakpoints.up('sm')]: {
      marginTop: '4rem'
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '4rem'
    }
  },
  k_content: {
    [theme.breakpoints.up('sm')]: {
      marginTop: '3rem'
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '2.5rem'
    }
  },
  poweredByLogoContainer: {
    [theme.breakpoints.down('xs')]: {
      marginTop: '7.5625rem'
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: '4rem'
    }
  },
  poweredByLogo: {
    width: '9.75rem',
    height: '1.375rem'
  },
  poweredByLogoStack: {
    width: '6.5625rem',
    height: '2.5625rem'
  },
  searchBoxContainer: {
    marginTop: '3rem'
  },
  categoryContainer: {
    [theme.breakpoints.down('xs')]: {
      marginTop: '2.875rem'
    },
    marginTop: '3.625rem'
  },
  textContainer: {
    textAlign: 'center',
    marginTop: '8rem',
    [theme.breakpoints.up('sm')]: {
      fontSize: '0.875rem',
      letterSpacing: '0.13px',
      lineHeight: '1.063rem'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
      letterSpacing: '0.11px',
      lineHeight: '0.938rem'
    }
  },
  k_textContainer: {
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      marginTop: '2rem',
      fontSize: '0.875rem',
      letterSpacing: '0.13px',
      lineHeight: '1.063rem'
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.75rem',
      letterSpacing: '0.11px',
      lineHeight: '0.938rem',
      marginTop: '1.5rem'
    }
  },
  paragraph: {
    color: '#0C2224'
  },
  keyword: {
    color: '#000000',
    fontWeight: 700
  },
  locationContainer: {
    marginTop: '1.75rem',
    paddingLeft: '1.3125rem'
  }
}));

export default useStyles;
